import FalconComponentCard from "components/common/FalconComponentCard";
import React from "react";
import { Button, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Form, useNavigate, useParams } from "react-router-dom";
import AddPriceForm from "./AddPriceForm";
import moment from "moment";
import { AddPriceService } from "../config/PriceApi";
import { toast } from "react-toastify";
import paths from "routes/paths";
import BackButton from "components/common/custom/back-button";

const AddPrice = ({ view }) => {
  const dispatch = useDispatch();
  const {
    control,
    watch,
    setValue,
    reset,
    handleSubmit,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: {},
  });

  const navigate = useNavigate();
  const { id } = useParams();

  const { allPermissionType } = useSelector((state) => state.role);
  const priceSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Price"
  );

  const { individualData } = useSelector((state) => state.price);

  const handleReset = () => {
    reset();
  };

  const handleAddPrice = async (data) => {
    const payload = {
      ...(id && { price_id: individualData?.price_id }),
      ...(id && { status: "Active" }),
      branch_id: id
        ? data?.branch?.branch_id
        : data?.branch?.map((item) => item?.value)?.join(",") || "",
      payer_id: data?.payer?.payer_id || "",
      nphies_code: data?.nphies_code || "",
      provider_cde: data?.provider_code || "",
      provider_cdedesc: data?.provider_description || "",
      prd_price: data?.price || "",
      prd_disc: data?.discount || "",
      prd_tax: data?.vat ?? "",
      actv_dte: data?.activiation_date
        ? moment(data?.activiation_date).format("YYYY-MM-DD")
        : "" || "",
    };

    const response = await dispatch(AddPriceService(payload)).unwrap();
    if (response?.success) {
      toast.success(response?.message_en);
      navigate(paths.priceList);
      navigate;
    } else {
      toast.error(response?.message_en);
    }
  };

  return (
    <>
      {((id ? Number(priceSetting?.edit) === 1 : Number(priceSetting?.add) === 1) || (view && Number(priceSetting?.view) === 1)) ? (
        <Form
          noValidate
          onSubmit={handleSubmit(handleAddPrice)}
          className="p-0"
        >
          <FalconComponentCard
            className="shadow-md"
            style={{ position: "relative" }}
          >
            <FalconComponentCard.Header
              className="d-flex  fixed-header justify-content-between align-items-center"
              sx={{
                position: "sticky !important",
                top: 68,
                zIndex: 1020,
                backgroundColor: "white",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <BackButton
                path={paths.priceList}
                title={`${id ? (view ? "View" : "Update") : "Add"} Price`}
              />
              <Col xs="auto" className="d-flex gap-2">
                {!view && (
                  <>
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={handleReset}
                    >
                      Reset
                    </Button>
                    <Button type="submit" size="sm" variant="success">
                      {id ? "Update" : "Add"}
                    </Button>
                  </>
                )}
              </Col>
            </FalconComponentCard.Header>
            <FalconComponentCard.Body
              style={{
                marginTop: "40px", // Adjust this value based on header height
                overflowY: "auto",
                maxHeight: "calc(100vh - 200px)", // Adjust based on your needs
              }}
            >
              <AddPriceForm
                watch={watch}
                setValue={setValue}
                errors={errors}
                control={control}
                isSubmitted={isSubmitted}
                view={view}
              />
            </FalconComponentCard.Body>
          </FalconComponentCard>
        </Form>
      ) : (
        <div className="py-6 text-center border rounded-3mb-3">
          <h5 className="text-danger">Permission Denied</h5>
          <p className="text-muted fs-11">
            You do not have permission to {view ? "view" : (id ? "edit" : "add")} Price.
          </p>
        </div>
      )}
    </>
  );
};

export default AddPrice;
